// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6308":"fd277b4b9b04d563","7218":"c1b7844c98c441b4"}[chunkId] + ".css";
};